import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";


const getClientSecret = async (taxAuthorityId, productType) => {
    const response = await axios.get(`orderPayment?taxAuthorityId=${taxAuthorityId}&productType=${productType}`, {headers: authHeader()});
    return response.data.result;
}

const invalidatePaymentIntent = async (paymentReference, paymentProvider) => {
    const response = await axios.post("orderPayment/invalidate", {paymentReference, paymentProvider}, {headers: authHeader()});
    return response.data.result;
}
export const orderPaymentApi = {
    getClientSecret,
    invalidatePaymentIntent,
}
